import { z } from "zod"

export const ReferralLeadResponseDataSchema = z.object({
  id: z.bigint().transform(String),
  companyName: z.string(),
  website: z.string().nullish(),
  contactName: z.string(),
  role: z.string().nullish(),
  email: z.string(),
  phone: z.string(),
  createdAt: z.date().transform((value) => value.toISOString()),
  credits: z.number(),
})

export const ReferralLeadsResponseDataSchema = z.array(ReferralLeadResponseDataSchema)

export const CreateReferralLeadResponseDataSchema = z.object({
  success: z.literal(true),
})
